import React, { useState, useRef, useEffect } from 'react';
import { useChat } from '../context/ChatContext';
import './Chester.css';

import {
  MessageSquare, 
  X,
  Send
} from "@geist-ui/icons";

const Chester = () => {
  const { messages, addMessage } = useChat(); // Replace local messages state with context
  const [input, setInput] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const messagesEndRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  // Scroll to the last bot message whenever messages change
  useEffect(() => {
    const botMessages = document.querySelectorAll('.chester-messages .message');
    if (botMessages.length > 0) {
      const lastBotMessage = botMessages[botMessages.length - 1];
      lastBotMessage.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [messages]);

  const callOpenAIAPI = async (message) => {
    try {
      const apiUrl = `${process.env.REACT_APP_AGENT_ENDPOINT}/api/v1/chat/completions`;
      console.log('Calling API at:', apiUrl);
        
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${process.env.REACT_APP_AGENT_KEY}`
        },
        body: JSON.stringify({
          model: 'n/a',
          messages: [
            {
              role: 'user',
              content: message
            }
          ]
        })
      });
  
      if (!response.ok) {
        console.error('API Response not OK:', response.status, response.statusText);
        const errorData = await response.json();
        console.error('Error details:', errorData);
        return 'Sorry, I could not process your request.';
      }
  
      const data = await response.json();
      console.log('API Response:', data);
  
      if (data.choices && data.choices.length > 0) {
        let botResponse = data.choices[0].message.content;
        return botResponse.trim();
      } else {
        console.error('Unexpected API response format:', data);
        return 'Sorry, I could not process your request.';
      }
    } catch (error) {
      console.error('Error calling API:', error);
      return 'Sorry, there was an error processing your request.';
    }
  };

  const handleSend = async () => {
    if (input.trim() === '') return;

    // Add user message to the chat
    addMessage('user', input);
    setIsLoading(true);

    // Call OpenAI API
    const response = await callOpenAIAPI(input);
    addMessage('bot', response);
    setIsLoading(false);

    setInput('');
  };

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <button className="chester-toggle" onClick={toggleChat}>
        { isOpen ? <X /> : <MessageSquare /> }
      </button>

      {isOpen && (
        <div className="chester-container">
          <div className="chester-header">
            <div className="chester-header-avatar">
              <img src="https://pub-3cbdf0fe4d9c40f19241eb1a5a52005c.r2.dev/om-assets/chest.webp" alt="Chester the AI"/>
            </div>

            <div className="chester-header-content">
              <span>Hi, I'm Chester</span>
              <p>Ask me anything about the game.</p>
            </div>
          </div>

          <div className="chester-messages">
            <div className="message bot"><pre style={{ whiteSpace: `pre-wrap` }}>How can I help you?</pre></div>

            {messages.map((msg, index) => (
              <div key={index} className={`message ${msg.sender}`}>
                {msg.sender === 'bot' ? (
                  <pre style={{ whiteSpace: 'pre-wrap' }}>{msg.text}</pre>
                ) : (
                  msg.text
                )}
              </div>
            ))}
            {isLoading && <div className="loading-message"><div></div><div></div><div></div></div>}
            <div ref={messagesEndRef} />
          </div>
          <div className="chester-input">
            <input 
              type="text" 
              value={input} 
              onChange={(e) => setInput(e.target.value)} 
              placeholder="Talk to Chester..."
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSend();
                }
              }}
            />
            <button onClick={handleSend}><Send /></button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chester;